/* esm.sh - extend@3.0.2 */
export * from "/*extend@3.0.2/esnext/extend.mjs";
export { default } from "/*extend@3.0.2/esnext/extend.mjs";
